import React from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ModalLegendaBolinhas({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-red-500"
              onClick={onClose}
            >
              <X size={20} />
            </button>

            <h2 className="text-xl font-bold mb-4 text-blue-700">📘 Legenda das Bolinhas</h2>
            <ul className="text-sm text-gray-700 space-y-3">

              <li>
                <span className="text-2xl">🟢</span> <b>Bolinha Verde:</b> Indica pacientes que já fecharam o tratamento e estão com todo processo comercial finalizado. Todas as tarefas foram concluídas e não há mais pendências ou ações futuras previstas. Representa sucesso total no funil!
              </li>
              <li>
                <span className="text-2xl">🟠</span> <b>Bolinha Laranja:</b> Indica pacientes com status de "Fechado Parcial" (fechou parte do tratamento ou ainda tem mais procedimentos para realizar), com tarefas futuras agendadas <b>e</b> acompanhamento ativo (interação registrada nos últimos 10 dias). Representa pacientes com grande potencial de novos negócios e que precisam ser acompanhados de perto para fechar mais etapas.
              </li>
              <li>
                <span className="text-2xl">🔵</span> <b>Bolinha Azul:</b> Indica pacientes que estão em negociação ativa (status "Negociando"), com tarefas futuras programadas e pelo menos uma interação registrada. São leads em estágio avançado do funil, próximos do fechamento, sem pendências críticas.
              </li>
              <li>
                <span className="text-2xl">🟡</span> <b>Bolinha Amarela:</b> Indica pacientes que possuem alguma pendência de interação ou atividade. São leads que precisam de atenção e acompanhamento para avançarem no funil. O objetivo é que, após as ações necessárias, esses pacientes evoluam para o status de bolinha azul ou laranja.
              </li>
              <li>
                <span className="text-2xl">🔴</span> <b>Bolinha Vermelha:</b> Indica pacientes em situação crítica que exigem ação imediata. São leads com pendências urgentes, como tarefas atrasadas, ou casos de "Fechado Parcial" sem interação recente (há mais de 10 dias). Também representa leads que estavam em estágio avançado e, por descuido, regrediram de nível. Atenção máxima!
              </li>
              <li>
                <span className="text-2xl">⚪️</span> <b>Bolinha Cinza:</b> Indica pacientes que acabaram de entrar no funil e ainda não receberam nenhuma interação ou ação do time. Esses leads precisam de atenção da equipe de vendas para iniciar o contato. Se permanecerem sem interação por dois dias, irão regredir para o status de alerta vermelho.
              </li>
              <li>
                <span className="text-2xl">⚫️</span> <b>Bolinha Preta:</b> Indica que o paciente foi marcado como perdido ou fechou com a concorrência. Normalmente, isso representa uma falha do nosso processo de vendas ou situações em que realmente não era possível converter esse paciente para a nossa clínica.
              </li>
              <li>
                <span className="text-2xl">🟣</span> <b>Bolinha Roxa:</b> Situação não mapeada por nenhuma regra anterior ("fallback"). Se aparecer roxa, revise as regras do funil ou entre em contato com o time de tecnologia — é um alerta para ajuste de lógica!
              </li>
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}